export const getFeatureFlag = (flag: string): boolean => {
  return import.meta.env[`VITE_${flag}`] === "true";
};
